<template>
  <div class="message-page">
    <app-header :title="title" left-name="close" />
    <div class="content">
      <textarea placeholder="给您的好友写些什么吧" v-model="message" type="text"></textarea>
      <button class="btn" @click="giveGift">赠送给好友</button>
    </div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
import { mapGetters } from 'vuex'
import Body from '@/mixins/body'
import { $toShare } from '@/utils/common/native-api'
import { getPageUrl } from '@/utils/common/url'
import { getCookie } from '@/utils/common/cookie'

export default {
  name: 'Message',
  data() {
    return {
      title: '好友赠言',
      message: '',
      contentNo: ''
    }
  },
  computed: {
    ...mapGetters('args', ['cardId'])
  },
  mixins: [Body],
  methods: {
    giveGift() {
      if (!this.message) {
        Toast({ message: '赠言不可为空哦~', position: 'bottom' })
        return
      }
      this.$store
        .dispatch('gift-card/card/saveCardMessage', {
          cardMessage: this.message,
          cardNo: this.cardId
        })
        .then(res => {
          this.contentNo = res.contentNo || res.messageNo
          // 获取跳转页面
          const sharePageUrl = getPageUrl({
            page: 'payment.html',
            route: '/gift-card',
            params: {
              sourceUserId: getCookie('appUserId'),
              cardId: this.cardId,
              contentNo: this.contentNo
            }
          })
          $toShare({
            message: '调起wx',
            sharePageUrl,
            shareMainTitle: this.$route.params.shareMainTitle,
            shareSecondTitle: this.$route.params.shareSecondTitle,
            shareImg: this.$route.params.shareImg,
            sharePlatform: 'wechatSession'
          })
        })
    }
  }
}
</script>

<style scope lang="less">
.message-page {
  width: 100%;
  height: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  .content {
    flex: 1;
    width: 100%;
    padding: 0.48rem;
    display: flex;
    flex-direction: column;
  }
  textarea {
    flex: 1;
    border: none;
    width: 100%;
    resize: none;
    outline: none;
    color: #00b25a;
    font-size: 0.3rem;
    text-shadow: 0px 0px 0px #000000; /* 文本颜色 */
    -webkit-text-fill-color: transparent;
    -webkit-user-select: auto !important;
  }
  textarea::-webkit-input-placeholder {
    color: #999999;
    text-shadow: none;
    -webkit-text-fill-color: initial;
  }
  .btn {
    padding: 0.24rem 0;
    background-color: #00b25a;
    color: #fff;
    border-radius: 0.12rem;
  }
}
</style>
